import { UseQueryOptions } from '@tanstack/react-query';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import { ContactColumn } from 'models/types';
import QueryKeys from './keys';

type Params = {
    recordTypes?: string[];
    reactQueryOptions?: UseQueryOptions<ContactColumn[], Error>;
};

const useContactColumnsMetadataExtended = ({ recordTypes, reactQueryOptions }: Params = {}) => {
    const axiosOptions = recordTypes?.length ? { params: { recordType: recordTypes.join(',') } } : undefined;
    return useQuery(
        QueryKeys.CONTACT_COLUMNS_METADATA_EXTENDED(recordTypes),
        CuredApiPaths.CUSTOMER_SUPPORT_CONTACT_COLUMNS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useContactColumnsMetadataExtended;
